var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 哈萨克斯坦 文莱 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }